module.exports = __webpack_public_path__ + "static/media/chat-icon-stop-audio.d0d3eabb.svg";